import React, { useState, useEffect, useRef } from "react";
import parse from 'html-react-parser';
import useAxios from "../../hooks/useAxios";
import { PageToolbar, TooltipWrapper } from "../common";
import InfoBlock from "../common/InfoBlock";
//Helper function, external library and Interfaces
import helpers from "../../_helpers/common";
import { useParams } from "react-router-dom";
import { ProductAsset, Product } from "../../types/interfaces";
import ImageGallery from "./ImageGallery";
import ReviewsList from "./ReviewsList";


const ViewDetails: React.FC = () => {
  const axiosInstance = useAxios();
  const { product_id } = useParams();
  const [results, setResults] = useState<Product | null>(null);
  const [reviewtype, setReviewType] = useState(1);
  const [productAssets, setProductAssets] = useState<ProductAsset[] | null>(null);
  
  const initialRequest = useRef(false);

  useEffect(() => {
    if (!initialRequest.current) {
      initialRequest.current = true;
      getDetailData();
    }
    return () => {
      setResults(null);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 

  const getDetailData = async () => {
    try {
      const response: any = await axiosInstance({
        url: "products/admin-product-detail",
        method: "GET",
        data: { productId: product_id },
      });
      //console.log("product details response", response);
      setResults(response.data.product_details);
      setProductAssets(response.data.product_assets);
    } catch (error: any) {
      console.error("Error in api request:", error);
    }
  };

  return (
    <>
      {/*Page toolbar Area Start*/}
      <PageToolbar
        title="Product Detail"
        step1={{ title: "Product List", link: "/product-list" }}
        step2={{ title: "Product Detail" }}
      />
      {/*Page toolbar Area End*/}
      <div id="kt_content" className="content flex-column-fluid">
	    {/*Top Info Start*/}
		<div className="card mb-5 mb-xxl-8">
		   <div className="card-body pt-4 pb-0">
			  <div className="d-flex flex-wrap flex-sm-nowrap">
				 <div className="me-7 mb-4">
					<div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
					   <img src={results?.displaypath} alt="image" />
					</div>
				 </div>
				 <div className="flex-grow-1">
					<div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
					   <div className="d-flex flex-column">
						  <div className="d-flex align-items-center mb-2">
							 <span className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">{results?.title}</span>
							 <span>
							   <i className={`ki-duotone ki-verify fs-1 ${Number(results?.status) === 1 ? "text-success" : "text-warning"}`}>
							   <span className="path1"></span>
							   <span className="path2"></span>
							   </i>
							 </span>
						  </div>
						  <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
							 <span className="d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2">
							    <i className="ki-duotone ki-information-4 text-primary fs-1 me-1">
							     <span className="path1"></span>
							     <span className="path2"></span>
							     <span className="path3"></span>
							    </i>
							    {
								  typeof results?.category_id === "object" && results?.category_id !== null
								  ? results?.category_id?.title
								  : ""
							    }
					         </span>
							 <span className="d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2">
							   <i className="ki-duotone ki-star text-warning fs-1 me-1">
							      <span className="path1"></span>
							      <span className="path2"></span>
							   </i>
							   {results?.avg_rating || "0.00"}
							 </span>
							 <span className="d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2">
							   <i className="ki-duotone ki-handcart text-info fs-1 me-1">
							      <span className="path1"></span>
							      <span className="path2"></span>
							   </i>
							   {results?.sold_count || 0}
							 </span>
							 <span className="d-flex align-items-center text-gray-500 text-hover-primary mb-2">
							   <i className="ki-duotone ki-eye text-primary fs-1 me-1">
							      <span className="path1"></span>
							      <span className="path2"></span>
							      <span className="path3"></span>
							   </i>
							   {results?.view_count || 0}
							 </span>
						  </div>
					   </div>
					</div>
					<div className="d-flex flex-wrap flex-stack">
					   <div className="d-flex flex-column flex-grow-1 pe-8">
						  <div className="d-flex flex-wrap">
							 <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
							    <div className="fw-semibold fs-6 text-gray-500">Price</div>
								<div className="d-flex align-items-center">
								   <div className="fs-2 fw-bold counted" data-kt-countup="true" data-kt-countup-value="4500" data-kt-countup-prefix="$" data-kt-initialized="1">{`Rs. ${results?.price}` || "0"}</div>
								</div>
							 </div>
							 <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
								<div className="fw-semibold fs-6 text-gray-500">Discount</div>
								<div className="d-flex align-items-center">
								   <div className="fs-2 fw-bold counted" data-kt-countup="true" data-kt-countup-value="80" data-kt-initialized="1">{`Rs. ${results?.discount_amount}` || "0"}</div>
								</div>
							 </div>
							 <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
								<div className="fw-semibold fs-6 text-gray-500">Sales Price</div>
								<div className="d-flex align-items-center">
								   <div className="fs-2 fw-bold counted" data-kt-countup="true" data-kt-countup-value="60" data-kt-countup-prefix="%" data-kt-initialized="1">{`Rs. ${results?.sales_price}` || "0"}</div>
								</div>
							 </div>
						  </div>
					   </div>
					</div>
				 </div>
			  </div>
		   </div>
		</div>
	    {/*Top Info End*/}
        <div className="card mb-6 mb-xl-2">
          {/* Description and other info */}
          <div className="card-body pt-6 pb-0">
            <div className="row">
              {/* Left column */}
              <div className="col-md-12">
                <div className="row g-4 mb-4">
                {/* Description and Special Condition */}
                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="border rounded p-3 h-100">
                      <div className="fs-6 fw-bold mb-2">Description:</div>
                      <div className="text-muted fs-7">
                        {results?.description
						  ? parse(results.description)
						  : "No description provided"
						}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 mt-4">
                    <div className="border rounded p-3 h-100">
                      <div className="fs-6 fw-bold mb-2">
                        Benefits:
                      </div>
                      <div className="text-muted fs-7">
					    {results?.benefits
						  ? parse(results.benefits)
						  : "No benefits provided"
						}
                      </div>
                    </div>
                  </div>
				  <div className="col-md-12 mt-4">
                    <div className="border rounded p-3 h-100">
                      <div className="fs-6 fw-bold mb-2">
                        How To Use:
                      </div>
                      <div className="text-muted fs-7">
					    {results?.how_to_use
						  ? parse(results.how_to_use)
						  : "No use info provided provided"
						}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Tabs */}
			<div className="row p-5">
				<ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
				  <li className="nav-item active">
					<a className="nav-link active" data-bs-toggle="tab" href="#product_images">
					  Product Images
					</a>
				  </li>
				  <li className="nav-item">
					<a className="nav-link" data-bs-toggle="tab" href="#reviews">
					  Reviews
					</a>
				  </li>
				</ul>
				<div className="tab-content mb-5">
				  <div className="tab-pane fade" id="reviews" role="tabpanel">
					{/*Review Tabs Start*/}
					<div className="mb-5">
					  <div className="card mb-5 px-4 py-4" style={{ maxHeight: "60vh", overflowY: "auto" }}>
						<ReviewsList productId={results?._id}/>
					  </div>
					</div>
					{/*Review Tabs End*/}
				  </div>
				  <div className="tab-pane fade active show" id="product_images" role="tabpanel">
					{/* Product Images */}
					<div className="mb-4">
					  {productAssets?.length === 0 ? (
						<div className="d-flex gap-3 flex-wrap">
						  No Images Uploaded
						</div>
					  ) : (
						<div className="card mb-5 px-4 py-4" style={{ maxHeight: "100vh", overflowY: "auto" }}>
						  <ImageGallery productAsset={productAssets}/>
						</div>
					  )}
					</div>
				  </div>
				</div>
			  </div>	
			</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDetails;
